import { render, staticRenderFns } from "./FilterItem.vue?vue&type=template&id=4025a371&scoped=true"
import script from "./FilterItem.vue?vue&type=script&lang=js"
export * from "./FilterItem.vue?vue&type=script&lang=js"
import style0 from "./FilterItem.vue?vue&type=style&index=0&id=4025a371&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4025a371",
  null
  
)

export default component.exports